module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_WoodMatted_MockedUp.cbaf5047.jpg";